/*
 * @Author: zhouzhuoxin
 * @Email: shzhouzhuoxin@jd.com
 * @Date: 2021-03-22 14:20:33
 * @Last Modified by: zhouzhuoxin
 * @Description: Description
 */
import React from 'react';
import TreeSelectAcore from './tree-select-acore';

export default React.forwardRef<any, any>(function treeSelectDepartment(props, ref) {
  return <TreeSelectAcore level={3} {...props} innerAPIType={2} ref={ref} />;
});

export async function validateSelectMax(rule: any, value: Array<any>) {
  const maxValue = 500;
  if (!value) return Promise.resolve();
  if (value.length > maxValue) throw Error(`最多选择${maxValue}个`);
  return Promise.resolve();
}
